/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./user-update-action-body').UserUpdateActionBody} UserUpdateActionBody
 */

/**
 * @typedef {import('./user-update-action-response').UserUpdateActionResponse} UserUpdateActionResponse
 */

/**
 * The path of the UserUpdateAction action.
 */
export const userUpdateActionPath = new SweetPath('/api/user/{user_id}', { path: '{param}' });

/**
 * Creates a contextualized UserUpdateAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createUserUpdateAction(axios) {
  /**
   * The userUpdateAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,body: UserUpdateActionBody } }
   *
   * @returns {Promise<UserUpdateActionResponse>}
   */
  function userUpdateAction({ headers = {}, parameters = {}, body } = {}) {
    const path = userUpdateActionPath.insert(parameters);

    return axios.put(path, body, { headers });
  }

  return userUpdateAction;
}
